import {
  Box,
  Grid,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { BirthdayGiftStore } from '@gamiphy/loyalty-station-desktop/store/birthdayGift';
import birthdayBackGround from './assets/birthdayBackGround.png';
import celebration from './assets/celebration.png';
import birthday from './assets/birthday.svg';
import InProgress from './InProgress';
import GoalAchieved from './GoalAchieved';

const BirthdayGiftCard: React.FC = () => (
  <Box
    p={1.5}
    sx={{
      border: (th) => `1px solid ${th.palette.primary.main}`,
      backgroundImage: `url(${birthdayBackGround})`,
      backgroundSize: 'cover',
    }}
    borderRadius="10px"
    bgcolor="#fff"
  >
    <Grid container direction="column" alignItems="center" wrap="nowrap" position="relative">
      {BirthdayGiftStore.isGoalAchieved && (
        <Box component="img" src={celebration} alt="Celebration" position="absolute" width="100%" />
      )}
      <Box component="img" src={birthday} alt="Birthday Cake" />
      {BirthdayGiftStore.isGoalAchieved ? <GoalAchieved /> : <InProgress /> }
    </Grid>
  </Box>
);

export default observer(BirthdayGiftCard);
